import { useMutation } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const MUTATION = graphql(`
  mutation UpdatePrintRule($id: ID!, $input: UpdatePrintRuleInput!) {
    updatePrintRule(id: $id, input: $input) {
      id
      name
      menuId
    }
  }
`);

export function useUpdatePrintRule() {
  return useMutation(MUTATION, {
    refetchQueries: ['PrintRule'],
  });
}
